// Single source of truth for breakpoints.
//
// Two systems need these values and they cannot share a TypeScript module:
//   - postcss.config.cjs feeds them to postcss-simple-vars, which textually
//     substitutes `$mantine-breakpoint-sm` in every *.module.css at build time.
//   - mantineTheme.ts feeds them to Mantine, which serves `visibleFrom`/
//     `hiddenFrom` and `useMediaQuery(theme.breakpoints.x)` at runtime.
// postcss config is loaded by postcss-loader as CommonJS with no TS transform in
// the chain, so this stays .cjs and is `require`d from both -- the same pattern
// primitives.tsx already uses for tokens.json (tsconfig sets neither
// resolveJsonModule nor ESM interop, so `require` is what works without config
// changes).
//
// Values are Mantine 9's own defaults, restated so the two consumers can be
// proven identical rather than coincidentally equal. Changing one now changes
// both; previously they could drift silently.
module.exports = {
  xs: '36em',
  sm: '48em',
  md: '62em',
  lg: '75em',
  xl: '88em',
};
